// The instructor's controls, as the student sees them (EDU-6, ARCH §29.8; D-TF-151/152):
// the centred freeze line, the full-screen eyes-up dim with the instructor's line, and the
// watch notice. Client-only chrome (ENG-1) over `game.eduControl`, which the server's
// `Lesson` frames set — the freeze itself is the server's input gate, never sim state.
import { h } from '../h';
import type { Game } from '../../boot';

/** Binding copy (§29.8, D-TF-157) — tests assert these verbatim. */
export const FROZEN_COPY = 'The instructor has paused you.';
export const EYES_UP_COPY = 'Eyes up.';
export const WATCHED_COPY = 'An instructor is watching.';

export class LessonHud {
  readonly el: HTMLElement;
  private readonly frozen: HTMLElement;
  private readonly eyesUp: HTMLElement;
  private readonly eyesText: HTMLElement;
  private readonly watched: HTMLElement;

  constructor() {
    this.frozen = h('div', { class: 'bb-edu-frozen', 'data-testid': 'edu-frozen' }, FROZEN_COPY);
    this.eyesText = h('div', { class: 'bb-edu-eyes-text', 'data-testid': 'edu-eyes-up-text' });
    this.eyesUp = h('div', { class: 'bb-edu-eyes', 'data-testid': 'edu-eyes-up' },
      h('div', { class: 'bb-edu-eyes-title', 'data-testid': 'edu-eyes-up-title' }, EYES_UP_COPY), this.eyesText);
    this.watched = h('div', { class: 'bb-edu-watched', 'data-testid': 'edu-watched' }, WATCHED_COPY);
    this.el = h('div', { class: 'bb-edu-hud' }, this.eyesUp, this.frozen, this.watched);
    // Inline so the overlay needs no stylesheet change to be legible.
    Object.assign(this.eyesUp.style, {
      position: 'fixed', inset: '0', background: 'rgba(0,0,0,0.72)', color: '#fff', display: 'none',
      flexDirection: 'column', alignItems: 'center', justifyContent: 'center', zIndex: '40', fontSize: '28px',
    });
    Object.assign(this.frozen.style, {
      position: 'fixed', top: '45%', left: '50%', transform: 'translate(-50%,-50%)', color: '#fff',
      textShadow: '0 0 4px #000', fontSize: '22px', display: 'none', zIndex: '41',
    });
    Object.assign(this.watched.style, {
      position: 'fixed', top: '12px', right: '12px', color: '#ffd166', textShadow: '0 0 3px #000', display: 'none', zIndex: '41',
    });
  }

  update(game: Game): void {
    const c = game.eduControl;
    this.frozen.style.display = c.frozen ? 'block' : 'none';
    this.eyesUp.style.display = c.eyesUp !== null ? 'flex' : 'none';
    this.eyesText.textContent = c.eyesUp ?? '';
    this.watched.style.display = c.watched ? 'block' : 'none';
  }
}
